import script from "./Homepage.vue?vue&type=script&setup=true&lang=js"
export * from "./Homepage.vue?vue&type=script&setup=true&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=6b0d4fee&lang=css"

const __exports__ = script;

export default __exports__